import React from 'react';
import { ReportErrors } from '@jira/platform__error-reporting/src/ReportErrors.tsx';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import { TransitionsQuery as OriginalTransitionsQuery } from './main.tsx';
import type { Props } from './types.tsx';

const WrappedTransitionsQuery = (props: Props): React.JSX.Element => (
	<ErrorBoundary id="issue.fields.status.transitions-query">
		<ReportErrors
			id="fields.status.transitions-query"
			packageName="jiraIssueFieldStatus"
			sendToPrivacyUnsafeSplunk
		>
			<OriginalTransitionsQuery {...props} />
		</ReportErrors>
	</ErrorBoundary>
);

export { WrappedTransitionsQuery as TransitionsQuery };
